import { Link } from "react-router-dom";
import GoalsTable from "./goals/GoalsTable";

type Props = {
	isSuperUser: boolean;
};

const Goals = ({ isSuperUser }: Props) => {
	return (
		<div className="container dashboards">
			<div className="row">
				<div className="col-md-12">
					<div className="dashboards__header">
						<h1>Goals</h1>
						<div className="dashboards__links">
							{isSuperUser && (
								<Link
									to="/admin/create-goal"
									className="btn btn-primary"
								>
									Create a goal
								</Link>
							)}
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">
					<GoalsTable isSuperUser={isSuperUser} />
				</div>
			</div>
		</div>
	);
};

export default Goals;
